// extracted by mini-css-extract-plugin
export default {"my20":"show_my20__rlzCz","title":"show_title__1VSr1","imgNews":"show_imgNews__xo-ox","imgTitle":"show_imgTitle__oywuF","teaser":"show_teaser__XBqWg"};